import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { StrainsPage } from './_dashboard.catalog.strains'

export const Route = createFileRoute('/_dashboard/catalog/strains/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: StrainsIndexPage,
})

function StrainsIndexPage() {
  return <StrainsPage selectedId={undefined} />
}
